import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '../components/user/LoginPage.vue'
import Totp from '../components/user/Totp.vue'
import Registration from '../components/user/Registration.vue'
import Activate from '../components/user/Activate.vue'
import Map from '../components/Map.vue'
import Navbar from '../components/Navbar.vue'
import ResetPasswordRequest from '../components/user/RequestResetPassword.vue'
import ResetPassword from '../components/user/ResetPassword.vue'
import Forbidden from '../components/user/Forbidden.vue'
import Dashboard from '../components/dashboard/MainDashboard.vue'
import ProjectListBoard from '../components/projectboard/ProjectListBoard.vue'
import ProjectManagement from '../components/projectboard/ProjectManagement.vue'
import store from '../store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'map',
      path: '/:workpack_id?/:token?',
      components: {
        header: Navbar,
        main: Map,
      },
      meta: {
        requireAuth: true
      },
      props: {
        main: true
      }
    },
    {
      name: 'login',
      path: '/login',
      components: {
        main: LoginPage,
      }
    },
    {
      name: 'verify',
      path: '/verify',
      components: {
        main: Totp,
        header: Navbar
      }
    },
    {
      name: 'reset-request',
      path: '/reset-password-request',
      components: {
        main: ResetPasswordRequest,
        header: Navbar
      }
    },
    {
      name: 'reset',
      path: '/reset-password',
      components: {
        main: ResetPassword,
        header: Navbar
      }
    },
    {
      name: 'reg',
      path: '/registration',
      components: {
        main: Registration
      }
    },
    {
      name: 'activate',
      path: '/activate-user',
      components: {
        main: Activate
      }
    },
    {
      name: 'forbidden',
      path: '/forbidden',
      components: {
        main: Forbidden
      }
    },
    {
      name: 'dashboard',
      path: '/dashboard/:workpack_id?',
      components: {
        main: Dashboard,
      },
      props: {
        main: true
      }
    },
    {
      name: 'project-list',
      path: '/project-list',
      components: {
        main: ProjectListBoard,
      },
      props: {
        main: true
      }
    },
    {
      name: 'project-management',
      path: '/project-management/:workpack_id?',
      components: {
        main: ProjectManagement,
      },
      meta: {
        requireAuth: true
      },
      props: {
        main: true
      }
    },
  ]
})

let counter = 0
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth && (!store.getters['user/authed'] || !store.getters['user/verified'] || store.getters['user/firstLoad'])) {

    if (store.getters['user/firstLoad']) {
      // store.commit('setIsLoading', true)
      Vue.http.get('/api/authed').then(response => {
        let projectBoardUser = false
        switch (true) {
          case to.path.includes('/project-management') && response.body.authed && response.body.verified:
            store.commit('user/authed', true)
            store.commit('user/verified', true)
            store.commit('user/settings', response.body.settings)
            store.commit('user/user', response.body.user)
            store.commit('user/userProjects', response.body.projects)
            projectBoardUser = response.body.user['groups'] && response.body.user['groups'].map(g => g.name).filter(name => name === 'projectDashboard').length > 0
            if (projectBoardUser) {
              store.commit('project/projectboardEnabled', true)
              next({name: 'project-management', params: { workpack_id: to.params.token}})
            } else {
              store.commit('user/firstLoad', false)
              next({name: 'map'})
            }
            break

          case to.path.includes('/project-list') && response.body.authed && response.body.verified:
            store.commit('user/authed', true)
            store.commit('user/verified', true)
            store.commit('user/settings', response.body.settings)
            store.commit('user/user', response.body.user)
            store.commit('user/userProjects', response.body.projects)
            projectBoardUser = response.body.user['groups'] && response.body.user['groups'].map(g => g.name).filter(name => name === 'projectDashboard').length > 0
            if (projectBoardUser) {
              store.commit('project/projectboardEnabled', true)
              next({name: 'project-list'})
            } else {
              store.commit('user/firstLoad', false)
              next({name: 'map'})
            }
            break

          case to.path.includes('/dashboard') && response.body.authed && response.body.verified:
            store.commit('user/authed', true)
            store.commit('user/verified', true)
            store.commit('user/settings', response.body.settings)
            store.commit('user/user', response.body.user)
            store.commit('user/userProjects', response.body.projects)
            let dashUser = response.body.user['groups'] && response.body.user['groups'].map(g => g.name).filter(name => name === 'dashboard').length > 0
            if (dashUser) {
              store.commit('project/dashboardEnabled', true)
              next({name: 'dashboard', params: { workpack_id: to.params.token}})
            } else {
              store.commit('user/firstLoad', false)
              next({name: 'map'})
            }
            break

          case to.path === '/activate-user' && response.body.authed && response.body.verified:
            next({name: 'activate', query: to.query})
            break
          case response.body.authed && response.body.verified:
            store.commit('user/authed', true)
            store.commit('user/verified', true)
            store.commit('user/settings', response.body.settings)
            store.commit('user/user', response.body.user)
            store.commit('user/userProjects', response.body.projects)
            // store.commit('setIsLoading', false)

            // TODO: uncomment to test release modal
            // localStorage.setItem("newRelease", true)
            store.commit('user/firstLoad', false)
            next()
            break

          case response.body.authed && !response.body.verified:
            next({name: 'verify'})
            break
          case to.path === '/reset-password':
            next({name: 'reset', query: to.query})
            break
          default:
            next({name: 'login'})
        }
      }, response => {
        next({name: 'login'})
      })
    } else {
      next({name: 'login'})
    }
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js